module.exports = __webpack_public_path__ + "assets/img/D3-Security-Content-Marketing-w720.35922b8e.jpg";